import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, Scroll} from "@angular/router";
import {MatTabGroup} from "@angular/material/tabs";
import {MerchantApi} from "../../../common/apis/merchant-api";
import {Merchant} from "../../../common/interfaces/Merchant";
import {MerchantService} from "../../../common/services/merchant.service";
import {MatDialog} from "@angular/material/dialog";
import {ClaimBusinessDialogComponent} from "./claim-business-dialog/claim-business-dialog.component";



@Component({
  selector: 'app-merchant',
  templateUrl: './merchant.component.html',
  styleUrls: ['./merchant.component.scss']
})
export class MerchantComponent implements OnInit {

  @ViewChild(MatTabGroup) matTabGroup: MatTabGroup;
  merchantId: string;
  merchant: Merchant | null = null
  links = ['home', 'menu','reviews', 'images&videos', 'location'];
  activeLink = this.links[0];
  merchantProfilePicture: string | null = null

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private merchantService: MerchantService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    // this.loadData()
    this.route.params.subscribe(params => {
      this.loadData();
    });
  }

  loadData() {
    this.merchantId = this.route.snapshot.params['slug'];
    this.merchantService.loadMerchantInfo(this.merchantId)
    // this.activeLink = "home"

    this.merchantService.getMerchantInfo().subscribe({
      next: (merchant) => {
        this.merchant = merchant
        this.merchantProfilePicture = merchant?.profilePictureURL ?? ""
      }
    })
    this.router.events.pipe().subscribe({
      next: (event) => {
        if (event instanceof Scroll) {
          if (event.routerEvent instanceof NavigationEnd) {
            /// This line sets the active tab to the
            let activeTab = event.routerEvent.url.substring(event.routerEvent.url.lastIndexOf("/") + 1)
            if (activeTab === 'menu') {
              this.activeLink = 'menu'
            } else if (activeTab === 'gallery') {
              this.activeLink = 'gallery'
            } else if (activeTab === 'reviews') {
              this.activeLink = 'reviews'
            } else if (activeTab === 'location') {
              this.activeLink = 'location'
            } else {
              this.activeLink = 'home'
            }
          }
        }
      }
    })
  }

  getMerchantBackground(): string {
    return this.merchant?.coverPhotoURL ?? "assets/merchant-background-placeholder.svg"
  }

  setDefaultPlaceholder() {
    this.merchantProfilePicture = "assets/merchant-placeholder.svg"
  }

  claimBusiness() {
    this.dialog.open(ClaimBusinessDialogComponent, {
      data: {
        merchantId: this.merchant?.id
      },
      width: '37rem'
    });
  }

}
